module.exports = __webpack_public_path__ + "img/icon1.dfe4dd7a.png";